export const weatherLocationPages = [
  ["Marine Weather Greece", "/weather", "Ionian and Aegean sailing forecast pages"],
  ["Sailing Weather Croatia", "/weather", "Adriatic wind, waves and marina departures"],
  ["Marine Weather Italy", "/weather", "Tyrrhenian, Adriatic and island cruising weather"],
  ["Marine Weather Spain", "/weather", "Balearics, Costa Brava and Atlantic coast checks"],
  ["Wind Forecast Mediterranean", "/weather/wind-guide", "Regional wind and sea-state planning"],
  ["Marine Weather Near Me", "/marine-weather-near-me", "Fast local forecast for nearby waters"],
];

export const weatherGuidePages = [
  ["Beaufort scale for sailing", "/weather/beaufort-guide", "Understand wind force in plain language"],
  ["Sea state guide", "/weather/sea-state-guide", "Match wave height to crew comfort"],
  ["How to read a marine forecast", "/weather/today-marine-forecast-guide", "Wind, gusts, waves, tide and visibility"],
  ["Wind guide", "/weather/wind-guide", "Read direction, speed and shifts"],
  ["Gusts guide", "/weather/gusts-guide", "Know when gust spread becomes risky"],
  ["Pressure guide", "/weather/air-pressure-guide", "Spot changing systems early"],
  ["Tide guide", "/weather/tide-guide", "Plan departures around water movement"],
  ["Sailing decision guide", "/weather/sailing-decision-guide", "Turn forecast data into go/no-go choices"],
];

export const weatherNearMePages = [
  ["Marinas near me", "/marinas-near-me"],
  ["Fuel near me", "/fuel-near-me"],
  ["Anchorages near me", "/anchorages-near-me"],
  ["Boat services near me", "/boat-services-near-me"],
  ["Sailing calculators", "/sailing-calculators"],
];

export const weatherFaqs = [
  ["What wind speed is safe for sailing?", "Many relaxed coastal trips feel comfortable around 5–15 knots, but safety depends on boat size, crew skill, gusts, wave height, route exposure and safe shelter options."],
  ["How high can waves be before sailing is unsafe?", "Small boats often become uncomfortable above 1–1.5 m, while larger yachts can handle more. Always consider wave period, wind direction, current and crew experience."],
  ["Is marine weather different from a regular weather forecast?", "Yes. Marine weather focuses on wind over water, gust spread, waves, swell, visibility, tides, sea state and coastal hazards, not only land temperature and rain."],
  ["How often should I check the forecast before departure?", "Check the day before, again on departure morning, and keep monitoring live conditions while underway because coastal wind and gusts can change quickly."],
];

export const weatherGlossary = ["Beaufort", "Gust spread", "Swell period", "Sea state", "Visibility", "Air pressure", "Tide window", "Go/no-go decision"];

export const weatherSeasons = [
  ["Greece", "Meltemi winds are strongest in summer, especially across the Aegean."],
  ["Croatia", "Bora and Jugo patterns can change Adriatic comfort quickly."],
  ["Italy", "Summer sea breezes help planning, while shoulder seasons need stronger pressure checks."],
  ["Mediterranean", "Local effects matter: headlands, islands and thermal winds can differ from the regional forecast."],
];

export const weatherComparisons = [
  ["Best marine weather apps for sailors", "Compare tools by marine layers, wave detail, route planning and clarity for non-experts."],
  ["Marine forecast vs regular weather forecast", "Explain why sailors need sea-state, gust, tide and visibility context before departure."],
];